import { Footer } from './modal.styles';

export default Footer;
